<!-- 
Shows the tabs for the provider page.
-->
<template>
  <v-card class="home">
    <v-tabs slider-color="primary" show-arrows>
      <v-tab key="summary" :to="getUrl('summary')">
        Summary
      </v-tab>
      <v-tab key="contacts" :to="getUrl('contacts')">
        Contacts
        <v-icon v-if="incompleteContacts" color="error" class="ml-2 tab-warning">error_outline</v-icon>
      </v-tab>
      <v-tab key="notices" :to="getUrl('notices')">
        Notices
      </v-tab>
      <v-tab key="invoices" :to="getUrl('invoices')">
        Invoices
      </v-tab>
      <v-tab key="notes" :to="getUrl('notes')">
        Notes&nbsp;
        <span v-if="provider && provider.noteCount > 0" class="caption">({{ provider.noteCount }})</span>
      </v-tab>
      <v-tab key="risk-profile" :to="getUrl('risk-profile')">
        Risk profile
      </v-tab>
      <v-tab key="history" :to="getUrl('history')">
        History
      </v-tab>
    </v-tabs>
    <slot/>
  </v-card>
</template>

<script>
import providerMixins from "./mixins";

export default {
  mixins: [providerMixins],
  watch: {
    loading() {
      if (!this.loading) {
        dispatchEvent(new Event("resize"));
      }
    }
  },
  methods: {
    getUrl(suffix) {
      return `/providers/${this.providerId}/${suffix}`;
    }
  }
};
</script>
